var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.layout === "productsList"
        ? _c("ProductsList", {
            attrs: {
              "sku-list": _vm.sku,
              title: _vm.title,
              "ga-list-value": _vm.galist,
              "widget-id": _vm.id
            }
          })
        : _vm.layout === "specialOffer"
        ? _c("SpecialOffer", {
            attrs: {
              "sku-list": _vm.sku,
              title: _vm.title,
              "ga-list-value": _vm.galist
            }
          })
        : _vm.layout === "productsSlider"
        ? _c("ProductsSlider", {
            attrs: {
              "sku-list": _vm.sku,
              title: _vm.title,
              "ga-list-value": _vm.galist
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }